import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Icons } from '@/js/libs/ui/src/V2';
import { isEqualOptions } from '../../helpers';
import { OptionWrapper, CheckmarkWrapper } from './styled';
const _OptionSelect = ({ option, selected, onClick, optionSelected, formatOptionLabel }) => {
    const isSelected = React.useMemo(() => {
        if (!selected) {
            return false;
        }
        return optionSelected ? optionSelected(selected, option) : isEqualOptions(selected, option);
    }, [selected, option, optionSelected]);
    const label = React.useMemo(() => (formatOptionLabel ? formatOptionLabel(option) : option.label), [formatOptionLabel, option]);
    return (_jsxs(OptionWrapper, { onClick: onClick, isSelected: isSelected, "data-testid": 'option-label', children: [_jsx("span", { children: label }), isSelected && (_jsx(CheckmarkWrapper, { children: _jsx(Icons.Checkmark, { size: 20 }) }))] }));
};
export const OptionSelect = React.memo(_OptionSelect);
